<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px" class="custom-field video-control"
	[id]="field?.fieldColumn">
	<label for="" *ngIf="![null, undefined, ''].includes(field?.fieldCaption) && field?.additionalMetaData?.showLabel">
		{{field?.fieldCaption}}
		<span *ngIf="field?.isRequired">*</span></label>
	<div class="video-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
		<ng-container *ngIf="!videoSrc">
			<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
				<!-- <button mat-stroked-button class="upload-btn">Upload</button> -->
				<div fxLayout="column" fxFlex="1 1" fxFlex.xs="100" fxLayoutAlign="start stretch" fxLayoutGap="5px"
					class="video-uploader">
					<input type="file" #file [id]="field?.fieldColumn" style="display: none;"
						[accept]="field?.additionalMetaData?.supportedType" (change)="uploadVideo($event, file)">
					<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px" class="video-uploader-info"
						(click)="triggerFile(file)" appDrag (files)="uploadVideo($event, file)">
						<div class="drop-box-title">{{ locale.translate('drop_video_desc') }} </div>
						<div class="drop-box-help-text" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayout="row"
							fxLayoutAlign="center center" fxLayoutGap="5px">
							<div fxLayout="row" fxLayoutAlign="start start" fxLayoutAlign.xs="center center" fxLayoutGap="5px">
								<label>{{ locale.translate('supported_formats') }}</label>
								<p>{{helpText.type}}</p>
							</div>
							<div fxLayout="row" fxLayoutAlign="start start" fxLayoutAlign.xs="center center" fxLayoutGap="5px">
								<label>{{ locale.translate('max_size') }}</label>
								<p>{{helpText.size}}</p>
							</div>
						</div>
					</div>
					<mat-hint
						*ngIf="(control.untouched || control.valid) && ![null, undefined, ''].includes(field.fieldHelpText)">
						{{field.fieldHelpText}}</mat-hint>
					<mat-error *ngIf="control.errors && control.touched"
						[innerHtml]="controlFunctions.validationMsg(control, field)">
					</mat-error>
				</div>
				<ng-container *ngIf="field?.helpLine?.length">
					<app-help-line [helpLineData]="field.helpLine" fxLayout="row" fxLayoutAlign="start start"
						(helpLineEmit)="helpLineData($event)"></app-help-line>
				</ng-container>
			</div>
		</ng-container>

		<ng-container *ngIf="videoSrc">
			<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.xs="column"
				fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px" class="video-process">
				<div fxFlex="213px" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"
					class="uploaded-video">
					<div class="cover-image" fxLayout="column" fxLayoutAlign="start stretch">
						<ng-container *ngIf="!state">
							<img [src]="videoThumbnail" alt="">
						</ng-container>
						<ng-container *ngIf="state">
							<video #videoSrcElement [src]="videoSrc"></video>
						</ng-container>
						<div class="overlay">
							<button class="play-btn" mat-icon-button (click)="pickThumbnail()">
								<mat-icon>play_arrow</mat-icon>
							</button>
						</div>
						<!-- <div class="loader">
            <span class="spinner"></span>
          </div> -->
					</div>
					<ng-container *ngIf="!multiType">
						<div class="options" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
							<span (click)="resetFile()">{{ locale.translate('remove') }}</span>
							<!-- <span>Change</span> -->
						</div>
					</ng-container>
				</div>
				<div class="cover-image-block" fxFlex="1 0" fxLayout="column" fxLayoutAlign="start stretch"
					fxLayoutGap.xs="10px" fxLayoutGap="30px">

					<ng-container *ngIf="!(cropper?.value?.imageSrc && !thumbanilCropped && !coverImageLoader)">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px" class="upload-cover-image">
							<div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
								<label>{{ locale.translate('cover_image_desc') }}</label>
							</div>
							<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
								<label>{{ locale.translate('upload_cover_image') }}</label>
								<input type="file" #thumbnailUpload style="display: none;"
									[accept]="field?.additionalMetaData?.thumbnailFormat"
									(change)="uploadThumbnail($event, thumbnailUpload)">
								<button mat-icon-button class="cover-img-btn" (click)="thumbnailUpload.click()">
									<mat-icon>publish</mat-icon>
								</button>
							</div>
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
								<mat-error *ngIf="inValidThumbnail" [innerHtml]="inValidThumbnail.file.message">
								</mat-error>
								<mat-error *ngIf="control.errors && control.touched"
									[innerHtml]="controlFunctions.validationMsg(control, field)">
								</mat-error>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="cropper?.value?.imageSrc && !thumbanilCropped  && !coverImageLoader">
						<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.xs="column"
							fxLayoutAlign.xs="start stretch" fxLayoutGap="16px" class="cover-control">
							<div class="cover-image" fxFlex="213px" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
								fxLayoutGap="0px">
								<!-- <img src="assets/img/training.jpg" alt=""> -->
								<ng-container *ngIf="!thumbanilCropped && !coverImageLoader">
									<app-image-crop [field]="cropper" [formControl]="cropperControl" [control]="cropperControl">
									</app-image-crop>
									<!-- <div>
										{{locale.translate('use_mouse_scroll_to_zoom')}}
									</div> -->
								</ng-container>
								<!-- <div class="loader">
              <span class="spinner"></span>
            </div> -->
							</div>
							<div class="button-blk" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px"
								fxLayout.xs="row wrap" fxLayoutAlign.xs="center center" fxLayoutGap="10px">
								<button mat-button class="stripped-btn" (click)="submit()">{{ locale.translate('ok') }}</button>
								<button mat-button class="primary-btn" (click)="removeThumbnail()">{{ locale.translate('cancel')
									}}</button>
							</div>
						</div>
					</ng-container>

					<!-- <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayout.xs="column"
          fxLayoutAlign.xs="start stretch" fxLayoutGap="10px" class="uploaded-cover-image">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="cover-image" fxFlex="200px" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
              fxLayoutGap="0px">
              <img src="assets/img/training.jpg" alt="">
              <div class="loader">
                <span class="spinner"></span>
              </div>
            </div>
          </div>
          <div class="options" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
            <span>Change</span>
          </div>
        </div> -->

				</div>
			</div>
		</ng-container>
	</div>
</div>
